import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import Download from "@material-ui/icons/CloudDownload";
import React, { useCallback, ChangeEvent } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { exportNodes } from  '../../../stores/actions/exportActions';
import { connect } from 'react-redux';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Node from '@material-ui/icons/Memory';
import utils from '../../../helpers/GlobalVariables';
import { Account, ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import _ from 'lodash';

import './Export.css';

interface IExportDevicesProps {
    account: Account;
    classes: ClassNameMap;
    exportFailed: boolean;
    exportFailedNoData: boolean;
    mobileView: boolean;
    isFileExporting: boolean;
    exportNodes: (sysID, sysName, allSystems) => void;
    systems: ISystem[];
}

const ExportDevices = ({
    exportFailed,
    exportFailedNoData,
    mobileView,
    exportNodes,
    systems,
    account,
    isFileExporting,
    ...props
}: IExportDevicesProps) => {
    const { classes } = props;
    const [pickedSystem, setPickedSystem] = useState<number|null|undefined>(null);
    const [allSystems, setAllSystems] = useState(false); 
    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const systemIds = systems.map(el => el.ID);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name])); 
 
    const closeExportNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_EXPORT_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        if (exportFailed || isFileExporting || exportFailedNoData) {
            closeNotificationTimer.current = setTimeout(closeExportNotification, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closeExportNotification, exportFailed, isFileExporting, exportFailedNoData]);


    const exportButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: exportFailed ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={!pickedSystem && !allSystems}
                onClick={(e) => { exportNodes(pickedSystem, pickedSystem ? systemNamesByIds[pickedSystem] : 'All', allSystems) }}
            >
                Export
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const headerStyle = utils.getHeaderStyle(exportFailed || exportFailedNoData);

        if (!mobileView) return null;
        if (exportFailed || isFileExporting || exportFailedNoData) {
            const className = exportFailed || exportFailedNoData ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {exportFailed
                        ? "Export failed."
                        : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };

    return (
        <Card className='exportDevicesForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Node />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Export Nodes</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()} disabled={!systems || !systems.length}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemIds}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystem}
                            disabled={allSystems}
                            onChange={(e, newVal) => setPickedSystem(newVal)}
                            renderInput={(systemIds) => <TextField {...systemIds} label='System' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                        <FormControlLabel
                            label="All systems"
                            style={{color: 'rgba(53, 53, 53, 0.87)'}}
                            control={
                            <Checkbox
                                style={{ color: 'rgb(0, 172, 193)' }}
                                checked={allSystems}
                                onChange={() => setAllSystems(!allSystems)}
                            />
                            }
                        />
                    </div>
                </FormControl>
                {renderMobileNotifications()}
                {exportButton()}
            </CardBody>
            {!mobileView ? (
                <>
                    <Snackbar
                        close
                        closeNotification={() => closeExportNotification()}
                        color={exportFailed || exportFailedNoData ? 'danger' : 'success'}
                        message={exportFailed ? 'Export failed.' : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                        open={exportFailed || isFileExporting || exportFailedNoData}
                        place='tc'
                    />
                </>
            ) : null}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    exportFailed: state.dashboard.exportFailed,
    exportFailedNoData: state.dashboard.exportFailedNoData,
    isFileExporting: state.dashboard.isFileExporting,
    mobileView: state.dashboard.mobileView
});
const actions = {
    exportNodes,
};

const ExportDevicesWithStyles = regularFormsStyle(ExportDevices);
export default connect(mapStateToProps, actions)(ExportDevicesWithStyles);
